import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class ContestantTime implements ISerialize {
    public Bib: number | null;

    public ClockTime: Date;

    public ContestantID: number | null;

    public Disabled: boolean;

    public EventID: number;

    public FreeText: string;

    public readonly Id: string | null;

    public StationID: number | null;

    public TUID: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Bib?: number | null;
        ClockTime?: Date;
        ContestantID?: number | null;
        Disabled?: boolean;
        EventID?: number;
        FreeText?: string | null;
        Id?: string | null;
        StationID?: number | null;
        TUID?: string | null;
    }) {
        this.Bib = values.Bib ?? null;

        this.ClockTime = values.ClockTime ?? new Date('1970-01-01T00:00:00.000');

        this.ContestantID = values.ContestantID ?? null;

        this.Disabled = values.Disabled ?? false;

        this.EventID = values.EventID ?? 0;

        this.FreeText = values.FreeText ?? '';

        this.Id = values.Id ?? '';

        this.StationID = values.StationID ?? null;

        this.TUID = values.TUID ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"ClockTime": ${'"' + formatDateIso(this.ClockTime) + '"'}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"Disabled": ${JSON.stringify(this.Disabled)}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"FreeText": ${JSON.stringify(this.FreeText)}` +
            ',' +
            `"Id": ${JSON.stringify(this.Id)}` +
            ',' +
            `"StationID": ${JSON.stringify(this.StationID)}` +
            ',' +
            `"TUID": ${JSON.stringify(this.TUID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ContestantTime from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Bib?: number | null;
        ClockTime?: Date;
        ContestantID?: number | null;
        Disabled?: boolean;
        EventID?: number;
        FreeText?: string | null;
        StationID?: number | null;
        TUID?: string | null;
    }): ContestantTime {
        return new ContestantTime(values);
    }

    public static _FromServerJson(json: any): ContestantTime {
        return new ContestantTime({
            Bib: json.Bib ?? null,
            ClockTime: json.ClockTime instanceof Date ? json.ClockTime : new Date(json.ClockTime),
            ContestantID: json.ContestantID ?? null,
            Disabled: json.Disabled,
            EventID: json.EventID,
            FreeText: json.FreeText ?? '',
            Id: json.Id ?? '',
            StationID: json.StationID ?? null,
            TUID: json.TUID ?? '',
        });
    }

    /**
     * Creates an instance of ContestantTime from another instance of ContestantTime.
     * @param other The ContestantTime you want to clone
     * @returns A cloned ContestantTime
     */
    public static FromOther(other: ContestantTime): ContestantTime {
        return ContestantTime._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ContestantTime.FromOther(this);
    }

    static NAME_OF_CLASS = 'ContestantTime';
}
